var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderNextIcconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 20,
    viewBox: "0 0 10 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49609 0.717773C1.30696 0.700338 1.11873 0.75849 0.972656 0.879883C0.826575 1.0013 0.734237 1.17608 0.716797 1.36523C0.699496 1.55392 0.758007 1.74182 0.878906 1.8877L7.26562 9.5459L7.64062 9.99609L7.27344 10.4521L1.10059 18.1113L1.09375 18.1201C1.00639 18.225 0.950654 18.3529 0.933594 18.4883C0.916631 18.6235 0.938583 18.7607 0.99707 18.8838C1.05569 19.007 1.14883 19.1114 1.26465 19.1836C1.38031 19.2556 1.51414 19.2935 1.65039 19.292V19.291L1.66113 19.292C1.76776 19.2924 1.87337 19.2683 1.96973 19.2227C2.04212 19.1883 2.10822 19.1419 2.16504 19.0859L2.21875 19.0273L9.11816 10.4561L9.12305 10.4502C9.22799 10.3225 9.28508 10.1624 9.28516 9.99707C9.28516 9.83319 9.22912 9.67409 9.12598 9.54688L1.98145 0.973633V0.972656C1.86003 0.826574 1.68524 0.735213 1.49609 0.717773Z",
    fill: "#006AB3",
    stroke: "#CD2A3F",
    strokeWidth: 1.42887
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderNextIcconNew);
export default __webpack_public_path__ + "static/media/sliderNextIcconNew.93674873115f138d8315424a555bcff7.svg";
export { ForwardRef as ReactComponent };